import { EntityKeyByReference } from '@card-software/library';
import { Business } from '../finance/business';
import { Invoice } from '../invoice/invoice';
import { ItemMaster } from '../item/item-master';
import { LocationPath } from '../location';
import { PurchaseOrder } from '../order/purchase-order/purchase-order';
import { UserLite } from '../user-master/user-lite';
import { Warehouse } from '../warehouse.ts/warehouse';
import { EntityKeyByNumber } from './keys/entity-key';

export interface LotItem {
  createdBy?: string;
  createdDate?: Date;
  currentLocationEntityKey?: EntityKeyByReference;
  customer?: Customer; // included only if get request sets materlizeLots is true
  customerOrderNumber?: string;
  customerReference?: string | null;
  dateReceived?: Date;
  exactLocationReference?: string;
  expiryDate?: Date; // PBI 4543: now a DateTime (was YearWeek)
  fieldToDisplay?: string;
  grossQuantity: number;
  id?: string;
  inbound: boolean;
  invoice?: Invoice; // included only if get request sets materlizeLots is true
  invoiceReference: string;
  isActive: boolean;
  item?: ItemMaster; // included only if get request sets materlizeLots is true
  itemCode: string;
  itemManufacturedDate?: YearWeek;
  local?: boolean;
  consumptionEntries: ConsumptionEntry[];
  additionEntries?: AdditionEntry[];
  locationReference?: string;
  modifiedBy?: string;
  modifiedDate?: Date;
  netQuantity: number;
  currentQuantity?: number;
  notes?: Note[];
  number?: string;
  originalGrossQuantity?: number;
  originalNetQuantity?: number;
  packagingType: number;
  provider?: Provider; // included only if get request sets materlizeLots is true
  providerLabelNumber: string;
  providerLotId: string;
  providerReference: string;
  batchReference?: string;
  batchNumber?: string; // resolved client-side from batchReference for display/grouping
  manufacturerReference?: string;
  manufacturer?: Business;
  received: boolean;
  UOM?: number;
  warehouse?: Warehouse; // included only if get request sets materlizeLots is true
  warehouseReference?: string;
  yarnLotItemDetails?: YarnLotItemDetails;
  parentKey?: EntityKeyByNumber;
  currentLocation?: LocationPath;
  movements: MovementLotItem[];
  currentLocationCode: string;
  currentLocationPath: LocationPath;
}

export interface LotItemSearch {
  lotItemNumber?: string;
  manufacturerLabelNumber?: string;
  initiator?: EntityKeyByReference;
  manufacturerReference?: string;
  location?: LocationPath;
}

export interface LotItemInsert {
  providerLotId: string;
  netQuantity: number;
  grossQuantity: number;
  itemCode: string;
  manufacturerReference: string;
  currentLocationCode: string;
  isActive: boolean;
  packagingType: number;
  notes?: string;
}

export interface ConsumptionEntry {
  quantity: number;
  initiator: EntityKeyByReference;
}

export enum AdditionEntryType {
  Composition = 0,
  Merge = 1,
}

export interface AdditionEntry {
  quantity: number;
  date: Date;
  initiator: EntityKeyByReference;
  comments?: string;
  user: UserLite;
  type: AdditionEntryType;
}

export interface MergeLotItemEntry {
  sourceLotItemId: string;
  quantity: number;
}

export interface YearWeek {
  year: number;
  week: number;
}

export interface YarnLotItemDetails {
  coneColor: string;
  coneCount: number;
}

export interface Provider {
  id: string;
  name: string;
  fieldToDisplay: string;
}

export interface Customer {
  name: string;
  id: string;
}
export interface Note {
  id?: string;
  richText: string;
  inResponseToReference?: string;
  userLite: UserLite;
  dateModified?: Date;
}

export interface InvoiceLotExtended {
  savedLots: LotItem[];
  localLots: LotItem[];
  purchaseOrder: PurchaseOrder;
  invoice: Invoice;
}

export interface SplitLotItem {
  id?: string;
  splitQuantity?: number;
  originalGrossQuantity: number;
  originalNetQuantity: number;
  packagingType: number;
}

export interface MovementLotItem {
  fromLocationCode: string;
  toLocationCode: string;
  comment?: string;
  movedBy: UserLite;
  movementDate: Date;
}
